import { render, staticRenderFns } from "./systemConfig.vue?vue&type=template&id=be1570e4&scoped=true"
import script from "./systemConfig.vue?vue&type=script&lang=js"
export * from "./systemConfig.vue?vue&type=script&lang=js"
import style0 from "./systemConfig.vue?vue&type=style&index=0&id=be1570e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1570e4",
  null
  
)

export default component.exports